<template>

    <v-dialog v-model="dialog" width="700px">
      <v-card>
        <p class=".title ma-2">Send preview to email</p>
        <v-form ref="sendMltt" v-model="sendMlttValid">
         <v-row no-gutters>
          <v-col class="ma-2">
            <v-text-field v-model="email_to" label="Email*" required :disabled="loading"></v-text-field>
          </v-col>
         </v-row> 
         <v-row v-if="this.mltt.mltp_nr == 1001 || this.mltt.mltp_nr == 1002" no-gutters>
          <v-col class="ma-2">
            <v-select v-model="termijn" :items="termijnen" label="Termijnen*" required :disabled="loading"></v-select>
          </v-col>
          <v-col class="ma-2">
            <v-switch v-model="reedsbetaald" label="Reeds betaald*" required :disabled="loading"></v-switch>
          </v-col>
          <v-col class="ma-2">
            <v-switch v-model="lastminute" label="Lastminute (7 dagen vvb)*" required :disabled="loading"></v-switch>
          </v-col>
          
         </v-row>  
         <v-row v-if="this.mltt.mltp_nr == 1212" no-gutters>
          <v-col class="ma-2">
            <v-select v-model="aanwie" :items="aanwiebetaal" label="Aan wie wordt er betaald?*" required :disabled="loading"></v-select>
          </v-col>
          <v-col class="ma-2">
            <v-select v-model="status" :items="statuskeuze" label="Boeking of annulering?*" required :disabled="loading"></v-select>
          </v-col>
         </v-row>  
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary mx-2" small @click="sendMltt(); loader = 'loading'" :disabled="!sendMlttValid" :loading="loading">Send mail</v-btn>
          <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
    
    <script>
    export default {
      data() { 
        return {
          dialog: false,
          sendMlttValid: false,
          huov_encrid: null,
          huov: {},
          kstp: {},
          mltt: {},
          email_to: '',
          loader: null,
          loading: false,
          termijn: '',
          termijnen: ['1' , '2'],
          aanwiebetaal: ['klant','vfy'], 
          aanwie: '',
          statuskeuze: ['B-STD',"B-AZV"],
          status: '',
          reedsbetaald: false,
          lastminute: false,
        }
      },
      watch: {
        loader () {
          const l = this.loader
          this[l] = !this[l]
        },
      },
      methods: {
        open(mltt) {
            this.$emit("showSnackbar");
            this.dialog = true;
            this.mltt = mltt;
            this.email_to = mltt.gebr_email;
        },
        sendMltt() { 
          this.$axios
            .post("ares/json/ares/syst/mltp/sendMltt.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "sendMltt"
              },
              sendMltt: {
                mltt:this.mltt,
                email_to:this.email_to,
                termijn:this.termijn,
                reedsbetaald:this.reedsbetaald,
                lastminute:this.lastminute,
                aanwie:this.aanwie,
                status:this.status,
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
              }  else {
                  this.$store.dispatch('setSnackbar', {
                  showing: true,
                  text: res.data.sendMltt.text,
                  color: res.data.sendMltt.color
                });
              }
              this.loader = null;
              this.loading = false;
              this.dialog = false;

            })
        }
      }
    }
    </script>
    
    